import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import HiringActions from '../actions/HiringActions';


const HiringSource = {

    getHiring() {
        return {
            remote(state, hiringId, candidateId) {
                const query = '?candidate=' + candidateId;
                return new SingleObjectResource(DJ_CONST.API.hiringDetail + query).fetch({pk: hiringId});
            },

            success: HiringActions.getHiringSuccess,
            error: CurrentUserActions.pageFault
        }
    },

    createHiring() {
        return {
            remote(state, shiftId) {
                return new SingleObjectResource(DJ_CONST.API.hiringList).post(null, {shift: shiftId});
            },

            success: HiringActions.getCreateSuccess,
            error: HiringActions.getCreateFailed
        }
    },

    deleteHiring() {
        return {
            remote(state, hiringId, shiftId, userId) {
                return new SingleObjectResource(DJ_CONST.API.hiringDelete).post({pk: hiringId}, {shift: shiftId, user: userId});
            },

            success: HiringActions.getDeleteSuccess,
            error: HiringActions.getDeleteFailed
        }
    },

    changeStatus() {
        HiringActions.clearStatusError();
        HiringActions.clearStatusSuccess();
        return {
            remote(state, pk, data) {
                return new SingleObjectResource(DJ_CONST.API.hiringChangeStatus).post({pk}, data);
            },

            success: HiringActions.getStatusChangeSuccess,
            error: HiringActions.getStatusChangeError
        }
    },

    likeCandidates() {
        return {
            remote(state, shiftId, likedCandidates, noShowCandidates, blockedCandidates) {
                return new SingleObjectResource(DJ_CONST.API.hiringLikeCandidates).post(null, {
                    shiftId: shiftId, candidates: likedCandidates, noShow: noShowCandidates, banned: blockedCandidates
                });
            },

            success: HiringActions.getLikeCandidatesSuccess,
            error: CurrentUserActions.pageFault
        }
    }
};

class HiringStore {
    constructor() {
        this.hiring = null;
        this.deleted = false;
        this.reloadPage = false;
        this.hiringError = null;
        this.success = null;
        this.created = false;
        this.exportAsync(HiringSource);
        this.bindActions(HiringActions);
    }

    onResetDeleted() {
        this.setState({deleted: false})
    }

    onGetDeleteSuccess() {
        this.setState({deleted: true, created: false, hiring: null});
    }

    onResetCreated() {
        this.setState({created: false, hiringError: null});
    }

    onGetCreateSuccess(hiring) {
        this.setState({hiring, created: true});
    }

    onGetCreateFailed(hiringError) {
        this.setState({hiringError, reloadPage: true});
    }

    onGetDeleteFailed(hiringError) {
        this.setState({hiringError, reloadPage: true});
    }

    onClearReloadPage() {
        this.setState({reloadPage: false});
    }

    onGetHiringSuccess(hiring) {
        this.setState({hiring})
    }

    onGetStatusChangeSuccess(resp) {
        this.success = resp;
    }

    onClearStatusSuccess() {
        this.success = null;
    }

    onGetStatusChangeError(error) {
        this.hiringError = error;
        this.reloadPage = true;
    }

    onClearStatusError() {
        this.hiringError = null;
    }
}

export default createStore(HiringStore, 'HiringStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/HiringStore.js
 **/